const shopifyImage = "https://cdn.shopify.com/s/files/1/0857/4644/files/IMG_5276.png?v=1713296290";
const awsImage = shopifyImage;

async function handleClosetAddToCart(closetId, versionId, env, update_only = false) {
  const closetFile = await getClosetCartFileFromLambda(closetId, versionId, env);
  if (!closetFile) {
    console.error("Failed to fetch closet cart file.");
    return false;
  }
  const closet = transformCloset(closetFile, closetId, env);
  await new Promise((resolve) => {
    updateShopifyCart(
      "edit",
      "designTool",
      closet.id,
      closet.closetName,
      shopifyImage,
      awsImage,
      closet.items,
      false,
      false,
      resolve,
      closet.closetLink,
      update_only
    );
  });
  return true;
}

(async function () {
  if (window.location.pathname !== "/cart") {
    return;
  }

  const url = new URL(window.location.href);
  const params = url.searchParams;

  const cartId = params.get("cart-id");
  const designType = params.get("design-type");
  const projectId = params.get("project_id");
  const closetId = params.get("closet_id");
  const versionId = params.get("version_id");

  const env = params.get("e") === "s" ? "staging" : "prod";
  const persist = params.get("persist") === "1";

  if (projectId && (closetId || versionId)) {
    console.warn("Both projectId and closetId/versionId found in URL parameters. Ignoring all.");
    return;
  }
  if (!projectId && !(closetId && versionId) && !cartId) {
    // console.log("[cart-manipulation] No projectId or closetId/versionId.");
    return;
  }
  if (cartId) {
    const cartFile = await getCartFileFromLambda(cartId);
    if (cartFile) {
      cartFile.designInfo.designType = designType;
      await addToCartWithDesignInfo(cartFile);
    } else {
      console.log("No cart file returned for ID", cartId);
    }
  } else if (projectId) {
    console.log("[cart-manipulation] projectId found:", projectId);
    const projectFile = await getProjectCartFileFromS3(projectId, env);
    if (!projectFile) {
      console.error("Failed to fetch project cart file.");
      return;
    }
    const closets = transformProject(projectFile, projectId);
    console.log("[cart-manipulation] Transformed closets:", closets);
    // Process closets sequentially to avoid race conditions
    for (let i = 0; i < closets.length; i++) {
      console.log(`[cart-manipulation] Processing closet ${i + 1} of ${closets.length}`);
      const closet = closets[i];
      await new Promise((resolve) => {
        updateShopifyCart(
          "edit",
          "designTool",
          closet.id,
          closet.closetName,
          shopifyImage,
          awsImage,
          closet.items,
          false,
          false,
          resolve, // Pass callback to know when this closet is done
          closet.closetLink
        );
      });
    }
    console.log("[cart-manipulation] All closets processed.");
  } else if (closetId && versionId) {
    // console.log("[cart-manipulation] closetId and versionId found:", closetId, versionId);
    const success = await handleClosetAddToCart(closetId, versionId, env);
    if (!success) return;
  }
  // refresh cart here to update with added items
  if (!persist) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("e");
    currentUrl.searchParams.delete("project_id");
    currentUrl.searchParams.delete("closet_id");
    currentUrl.searchParams.delete("version_id");
    currentUrl.searchParams.delete("cart-id");
    currentUrl.searchParams.delete("design-type");
    currentUrl.searchParams.delete("is-mobile");
    currentUrl.searchParams.delete("loadDesign");
    currentUrl.searchParams.delete("designID");
    history.replaceState(null, "", currentUrl.toString());
    location.reload();
  }
  // If persist is true, do nothing - no reload to avoid infinite loop
})();

// The design tool remembers which closets it put in the cart, but it cannot
// read /cart.js across origins. Tell it which design-tool closets the cart
// actually holds, so a closet the customer removed (or ordered) stops showing
// "Update Cart" and never raises the out-of-date banner.
async function sendCartDesignIdsToTool() {
  const frames = Array.from(document.querySelectorAll("iframe")).filter((f) =>
    /modularclosets/.test(f.getAttribute("src") || "")
  );
  if (frames.length === 0) return;
  let closetIds = [];
  try {
    const cart = await (await fetch("/cart.js")).json();
    closetIds = (cart.items || [])
      .map((item) => {
        const p = item.properties || {};
        const id = p._designId || p.designId;
        return typeof id === "string" && id.includes("closetVersionId=") ? id.split("&")[0] : null;
      })
      .filter(Boolean);
  } catch (err) {
    console.error("[cart-manipulation] Could not read the cart for the design tool:", err);
    return;
  }
  frames.forEach((frame) => {
    try {
      const origin = new URL(frame.src).origin;
      frame.contentWindow.postMessage({ type: "cartDesignIds", payload: { closetIds } }, origin);
    } catch (err) {
      console.error("[cart-manipulation] Could not message the design tool frame:", err);
    }
  });
}

(function () {
  const frames = Array.from(document.querySelectorAll("iframe")).filter((f) =>
    /modularclosets/.test(f.getAttribute("src") || "")
  );
  if (frames.length === 0) return;
  frames.forEach((frame) => frame.addEventListener("load", () => setTimeout(sendCartDesignIdsToTool, 1500)));
  // The tool may already be running by the time this script executes.
  setTimeout(sendCartDesignIdsToTool, 2000);
  // Coming back to this tab after editing the cart elsewhere.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") sendCartDesignIdsToTool();
  });
})();

var receiveMessage = async function (event) {
  if (event.data.type === "addToCart") {
    console.log("[cart-manipulation] Message received:", event.data);
    console.log("[cart-manipulation] Message Type:", event.data.type);
    addToCartWithDesignInfo(event.data.payload);
  } else if (event.data.type === "designToolAddToCart") {
    console.log("[cart-manipulation] Message received:", event.data);
    console.log("[cart-manipulation] Message Type:", event.data.type);
    const payload = event.data.payload;
    const closetId = payload.closetId;
    const versionId = payload.versionId;
    const env = payload.env === "s" ? "staging" : "prod";
    const redirect = payload.redirect !== false;
    const update_only = payload.update_only === true;
    if (!(closetId && versionId)) {
      console.error("Missing closetId or versionId in payload.");
      return;
    }
    await handleClosetAddToCart(closetId, versionId, env, update_only);
    if (redirect) {
      window.location.href = "/cart";
    } else {
      sendCartDesignIdsToTool();
    }
  } else if (event.data.type === "setProjectId") {
    console.log("[cart-manipulation] Message received:", event.data);
    console.log("[cart-manipulation] Message Type:", event.data.type);
    const payload = event.data.payload;
    const projectId = payload.project_id;
    const closetId = payload.closet_id;

    if (!projectId) {
      console.error("Missing projectId in payload.");
      return;
    }

    // Save to localStorage for persistence across navigation
    localStorage.setItem("design_tool_project_id", projectId);
    if (closetId) localStorage.setItem("design_tool_closet_id", closetId);

    // Create URL object from current page location and add parameters cleanly
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("project_id", projectId);
    if (closetId) currentUrl.searchParams.set("closet_id", closetId);

    // Update the browser URL without reloading
    history.replaceState(null, "", currentUrl.toString());
    console.log("[cart-manipulation] Updated URL:", currentUrl.toString());
  } else if (event.data.type === "designToolSignOut") {
    console.log("[cart-manipulation] Design tool sign out received");
    localStorage.removeItem("design_tool_project_id");
    localStorage.removeItem("design_tool_closet_id");
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("project_id");
    currentUrl.searchParams.delete("closet_id");
    history.replaceState(null, "", currentUrl.toString());
    location.reload();
  } else if (event.data.type === "REDIRECT_HOME") {
    location.assign("/");
  }
};
if (
  window.location.pathname === "/pages/closet-design-tool" ||
  window.location.pathname === "/pages/design-tool" ||
  window.location.pathname === "/pages/garage-closet-design-tool" ||
  window.location.pathname === "/pages/alto-closet-design-tool" ||
  window.location.hostname.includes("17squares.com")
) {
  window.addEventListener("message", receiveMessage, true);
}

async function updateShopifyCart(
  action,
  designType,
  id,
  closetName = null,
  shopifyImage = null,
  awsImage = null,
  items = [],
  draftOrder = false,
  isLastCloset = true,
  callback = null,
  closetLink = null,
  update_only = false
) {
  const baseUrl = "/cart";

  // Helper function to add items to the cart with line item properties
  function addToCart(items) {
    console.log("[cart-manipulation] Add to Cart reached with items:", items);
    return new Promise((resolve, reject) => {
      const _designName = closetName || id;

      let bundleName = `${designType} Design - ${_designName}`;
      let designUrl = `https://modularclosets.com/collections/milano?designId=${id}#configurator`;

      if (designType === "17Squares") {
        bundleName = `Custom Closet Design - ${_designName}`;
        designUrl = `https://modularclosets.com/pages/closet-design-tool?designId=${id}`;

        updateShopifyCookieVariable("utm_content", "17Squares");
      }

      if (designType === "designTool") {
        bundleName = `Custom Closet Design - ${_designName}`;
        designUrl =
          closetLink ?? `https://modularstudio.modularclosets-apps.com/design?project_id=${id}`;
      }
      if (designType === "Verra") {
        bundleName = `Verra Design - ${_designName}`;
        designUrl = `https://modularclosets.com/collections/verra-configurator?designId=${id}#configurator`;
      }

      if (window.location.pathname === "/pages/garage-closet-design-tool") {
        designUrl = `https://modularclosets.com/pages/garage-closet-design-tool?designId=${id}`;
      } else if (window.location.pathname === "/pages/alto-closet-design-tool") {
        designUrl = `https://modularclosets.com/pages/alto-closet-design-tool?designId=${id}`;
      }

      // Grab the UA string
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Test against common mobile identifiers
      const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

      console.log(`Running on a ${isMobile ? "mobile" : "desktop"} device.`);

      const designTypeText = isMobile ? `${designType}-mobile` : designType;

      updateShopifyCookieVariable("design_type", designTypeText);

      const payload = items.map((item) => ({
        id: item.id,
        quantity: item.quantity,
        properties: {
          _designId: id,
          _shopifyImage: shopifyImage,
          _awsImage: awsImage,
          _designImage: shopifyImage, //TODO remove from extension and stick with _shopifyImage
          _designType: designTypeText, // Use the variable
          _designUrl: designUrl,
          _designName: _designName, // Use the variable
          _bundleName: bundleName,
          _env: item.properties?._env || null,
          _closetVersionId: item.properties?._closetVersionId || null,
          _projectId: item.properties?._projectId || null,
        },
      }));
      console.log("[cart-manipulation] Payload to add:", payload);
      const isFrom17Squares = document.referrer.includes("17squares.com");

      fetch(`${baseUrl}/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: payload }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("[cart-manipulation] Success:", data);

          if (isLastCloset) {
            if (isFrom17Squares) {
              // Redirect to /cart instead of showing mini cart
              window.location.href = "/cart";
            } else if (window.location.pathname === "/cart") {
              if (window.theme && window.theme.mini_cart) {
                window.theme.mini_cart._updateMinicartData(1);
              }
            } else {
              var configuratorOverlays = document.querySelectorAll(".mc-loading-overlay");
              for (var o = 0; o < configuratorOverlays.length; o++) {
                configuratorOverlays[o].style.display = "none";
                configuratorOverlays[o].style.zIndex = "-1";
              }
              // Ensure minicart opens for configurator adds (e.g. Verra); PDP upsell sets skipMinicart
              if (window.theme) window.theme.skipMinicart = false;
              // Open minicart on success so user gets clear feedback (e.g. Verra add-to-cart)
              if (window.theme && window.theme.mini_cart) {
                window.theme.mini_cart._updateMinicartData(1);
                window.theme.mini_cart._openMinicart(1, true);
                setTimeout(function () {
                  var overlaysAgain = document.querySelectorAll(".mc-loading-overlay");
                  for (var i = 0; i < overlaysAgain.length; i++) {
                    if (overlaysAgain[i].style.display !== "none") {
                      overlaysAgain[i].style.display = "none";
                      overlaysAgain[i].style.zIndex = "-1";
                    }
                  }
                  var drawer = document.querySelector("component-minicart.mini-cart, .mini-cart");
                  if (drawer && !drawer.classList.contains("active")) {
                    drawer.classList.add("active");
                  }
                  if (drawer) {
                    drawer.style.zIndex = "110";
                  }
                }, 150);
              } else {
                console.error("Mini cart component is not initialized.");
              }
              // Cart icon brief highlight
              const cartBtn =
                document.querySelector("[data-minicart-toggle]") ||
                document.querySelector(".minicart-button");
              if (cartBtn) {
                cartBtn.setAttribute("data-just-added", "true");
                setTimeout(() => cartBtn.removeAttribute("data-just-added"), 3000);
              }
              if (designType === "Verra") {
                document.dispatchEvent(new CustomEvent("verraAddedToCart"));
              }
            }
          }
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        })
        .finally(() => {
          // Refresh cart count only; do not open minicart on failure (open happens in .then() on success)
          if (isLastCloset && !isFrom17Squares && window.theme && window.theme.mini_cart) {
            window.theme.mini_cart._updateMinicartData(1);
          }
        });
    });
  }

  // Function to edit cart items based on the item title
  function editCartItem(items) {
    console.log("[cart-manipulation] Edit Cart Items:", items);
    console.log("[cart-manipulation] Closet Name:", closetName);
    return new Promise((resolve, reject) => {
      fetch(`${baseUrl}.js`)
        .then((response) => response.json())
        .then((cart) => {
          // A design is several cart lines, one per variant, all stamped with
          // the same _designId. Replacing it means removing every one of them,
          // not just the first, or the cart ends up as a mix of old and new.
          const matchesDesign = (item) => {
            // Every writer in this file stores the id as the hidden property
            // `_designId` (see addToCart); the bare `designId` is never set, so
            // this match used to fail every time and an edited design was added
            // on top of the old one instead of replacing it.
            const cartDesignId =
              item.properties &&
              (item.properties._designId || item.properties.designId);
            if (!cartDesignId || typeof cartDesignId !== "string") return false;
            const isCustomer = cartDesignId.includes("closetVersionId=");
            const isInteriorDesigner = id.includes("closet_id=");
            const is17Squares = /^\d+$/.test(id);

            if (is17Squares) {
              // 17 Squares: designId is simply a digit, direct match
              return cartDesignId === id;
            } else if (isCustomer) {
              // Customer: match on first segment (closetId)
              const baseId = id.split("&")[0];
              return cartDesignId.startsWith(baseId);
            } else if (isInteriorDesigner) {
              // Interior designer: extract closet_id from incoming id and match
              const match = id.match(/closet_id=([^&]+)/);
              const closetId = match ? match[1] : null;
              return closetId && cartDesignId.includes(closetId);
            }
            return false;
          };
          const targetKeys = cart.items.filter(matchesDesign).map((item) => item.key);

          // Seen once on 2026-10-08: remove + add both reported success, yet
          // the design line was gone from the cart moments later. Re-read the
          // cart after the add and, if the design is missing, add it once more
          // and say so, rather than leave the customer with an emptied cart.
          const verifyDesignInCart = () =>
            new Promise((resolve) => setTimeout(resolve, 1500))
              .then(() => fetch(`${baseUrl}.js`))
              .then((response) => response.json())
              .then((after) => {
                if ((after.items || []).some(matchesDesign)) return;
                console.warn(
                  "[cart-manipulation] Design missing from cart after replace; adding it again.",
                  after.items
                );
                return addToCart(items);
              })
              .catch((error) => {
                console.error("[cart-manipulation] Could not verify the cart after replace:", error);
              });

          console.log("[cart-manipulation] Target keys:", targetKeys, cart.items);
          if (targetKeys.length > 0) {
            // Remove every line of the old design in one call, then add the new list
            const updates = {};
            targetKeys.forEach((key) => {
              updates[key] = 0;
            });
            fetch(`${baseUrl}/update.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            })
              .then((response) => response.json())
              .catch((error) => {
                // If the removal fails we still add the new lines, which is what
                // happened before this replace path worked at all.
                console.error("[cart-manipulation] Failed to remove old design lines:", error);
              })
              .then(() => addToCart(items))
              .then(() => verifyDesignInCart())
              .then(() => resolve())
              .catch((error) => {
                console.error("Error:", error);
                reject(error);
              });
          } else if (update_only) {
            console.log("[cart-manipulation] update_only: item not in cart, skipping add.");
            resolve();
          } else {
            console.error("Item not found in cart");
            addToCart(items)
              .then(() => resolve())
              .catch((error) => reject(error));
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  }

  async function createDraft(email = null, items, discount = 0, designType = null) {
    const _designType = designType || "Milano";
    const _designName = closetName || id;
    let designUrl = `https://modularclosets.com/collections/milano?designId=${id}#configurator`;

    if (designType && designType === "Verra") {
      designUrl = `https://modularclosets.com/collections/verra-configurator?designId=${id}#configurator`;
    }

    const payload = items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      properties: {
        _designId: id,
        // _shopifyImage: shopifyImage,
        // _awsImage: awsImage,
        // _designImage: shopifyImage,
        // _designType: _designType,
        // _designName: _designName,
        // _bundleName: `${_designType} Design - ${_designName}`,
        // designType: _designType,
        Design_Url: designUrl,
        Design: `${_designType} Design - ${_designName}`,
        Image: shopifyImage,
      },
    }));
    try {
      const response = await fetch(
        "https://modular-bundles--development.gadget.app/reps/createDraft",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            items: payload,
            discount: discount,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log("[cart-manipulation] Draft created successfully:", data);
        const invoiceUrl = data.invoiceUrl;
        const invoiceId = data.invoiceId.split("/").pop(); // Extracting the numeric ID from the gid

        // Update the invoice result section
        document.getElementById(
          "invoice-url"
        ).innerHTML = `Invoice URL: <a href="${invoiceUrl}" target="_blank">${invoiceUrl}</a>`;
        document.getElementById(
          "invoice-link"
        ).innerHTML = `Admin Dashboard: <a href="https://modularclosets.com/admin/draft_orders/${invoiceId}" target="_blank">View Invoice in Admin Dashboard</a>`;

        // Display the copy URL button
        const copyButton = document.getElementById("copy-url-btn");
        copyButton.style.display = "block";
        copyButton.onclick = function () {
          navigator.clipboard.writeText(invoiceUrl).then(
            function () {
              alert("URL copied to clipboard!");
            },
            function () {
              alert("Failed to copy URL.");
            }
          );
        };
        return data.draftUrl; // Returning the URL to the newly created Shopify draft order
      } else {
        throw new Error(data.message || "Failed to create draft order");
      }
    } catch (error) {
      console.error("Error creating draft:", error);
      throw error;
    }
  }

  // Determine action to perform
  if (draftOrder) {
    console.log("[cart-manipulation] Draft order action triggered");
    const emailInput = document.getElementById("rep-email");
    console.log("[cart-manipulation] emailInput:", emailInput);
    const email = emailInput.value || "";

    const discountInput = document.querySelector(".discount-percent input");
    console.log("[cart-manipulation] discountInput:", discountInput);
    const discountValue = parseFloat(discountInput.value) || 0; // Ensure the discount is a number

    await createDraft(email, items, discountValue, designType);
  } else if (action === "add") {
    await addToCart(items);
  } else if (action === "edit") {
    await editCartItem(items);
  } else if (action === "createDraft") {
    // let email ="jay@strongerecommerce.com"
    // createDraft(email, items);
  } else {
    console.error("Invalid action specified");
  }

  // Call callback once at the end after all async operations complete
  if (callback) callback();
}

async function addToCartWithDesignInfo(cartData) {
  // Extract design info and items from the cartData
  let { designInfo, items } = cartData;

  if (!items || typeof items !== "object") {
    console.log("[cart-manipulation] Invalid or missing cart data.");
    return; // Exit the function early if cartData is not an object
  }

  items = Object.entries(items).map(([id, quantity]) => ({
    id,
    quantity,
  }));

  console.log("[cart-manipulation] designInfo:", designInfo);
  console.log("[cart-manipulation] items:", items);

  // Check if the items array is empty, and return early if it is
  if (Object.keys(items).length === 0) {
    console.log("[cart-manipulation] No items to add to cart.");
    return; // Exit the function early
  }

  await updateShopifyCart(
    "edit",
    designInfo.designType,
    designInfo.designID,
    designInfo.designName,
    shopifyImage,
    awsImage,
    items
  );
}

// Function to get a cookie's value
function getCookie(name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
  return null;
}

// Function to set or update the _shopify_sa_p cookie for utm_content only
function updateShopifyCookieVariable(variable, value) {
  const cookieName = "_shopify_sa_p";
  let cookieValue = getCookie(cookieName) || "";
  const encodedValue = encodeURIComponent(value);

  // Construct new value for the parameter
  const newParam = variable + "=" + encodedValue;

  // Regex to match the param (e.g. utm_content=...)
  const regex = new RegExp(variable + "=[^&;]*");

  if (regex.test(cookieValue)) {
    // Replace existing
    cookieValue = cookieValue.replace(regex, newParam);
  } else {
    // Append if not found
    cookieValue += (cookieValue ? "&" : "") + newParam;
  }

  // Set the cookie with updated value (7 day expiry)
  document.cookie =
    cookieName +
    "=" +
    cookieValue +
    "; path=/; expires=" +
    new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString();
}

function getClosetCartFileFromLambda(closetId, versionId, env) {
  const prodUrl = "https://c5yrzoqybg.execute-api.us-east-2.amazonaws.com/Prod";
  const stagingUrl = "https://ypufnk6x0b.execute-api.us-east-2.amazonaws.com/Prod";
  const baseUrl = env === "prod" ? prodUrl : stagingUrl;
  const url = `${baseUrl}/api/modular-studio/quotes/${closetId}/cart?versionId=${versionId}`;
  // console.log("[cart-manipulation] Fetching closet cart file from URL:", url);
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": "2a1c0e3f-4b8d-4a5c-9f7b-0d6e1f3a2b5d",
    },
  })
    .then((r) => {
      if (!r.ok) throw new Error("Closet cart fetch failed");
      return r.json();
    })
    .catch((err) => {
      console.error("Error fetching closet cart file:", err);
      return null;
    });
}

function getProjectCartFileFromS3(projectId, env) {
  const envSuffix = env === "staging" ? "-staging" : "";
  const url = `https://design-files-retail${envSuffix}.s3.us-east-2.amazonaws.com/public/projects/project-${projectId}/cart.json`;
  return fetch(url)
    .then((r) => {
      if (!r.ok) throw new Error("Project cart fetch failed");
      return r.json();
    })
    .catch((err) => {
      console.error("Error fetching project cart file:", err);
      return null;
    });
}

function transformProject(closets, projectId) {
  return closets.map(({ ClosetId, ClosetName, CartItems, ClosetLink }) => ({
    id: ClosetId,
    closetName: ClosetName,
    closetLink: ClosetLink,
    items: CartItems.map(({ qty, variantId }) => ({
      id: variantId,
      quantity: qty,
      properties: {
        _designName: ClosetName,
      },
    })),
  }));
}

function transformCloset(closetFile, closetId, env) {
  return {
    id: closetId + "&env=" + env + "&closetVersionId=" + closetFile.closetVersionId,
    closetName: closetFile.closetName,
    closetLink: closetFile.closetLink,
    items: closetFile.cartItems.map(({ qty, variantId }) => ({
      id: variantId,
      quantity: qty,
      properties: {
        _designName: closetFile.closetName,
        _env: env,
        _closetVersionId: closetFile.closetVersionId,
        _projectId: closetFile.projectId,
      },
    })),
  };
}

function getCartFileFromLambda(guid) {
  const url = `https://c5yrzoqybg.execute-api.us-east-2.amazonaws.com/Prod/api/cart/${guid}?api-key=bb8a1199-43d3-46f3-816e-1c2da0f86aa3`;
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": "2a1c0e3f-4b8d-4a5c-9f7b-0d6e1f3a2b5d",
    },
  })
    .then((r) => {
      if (!r.ok) throw new Error("Cart fetch failed");
      return r.json();
    })
    .catch((err) => {
      console.error("Error fetching cart file:", err);
      return null;
    });
}
